import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation27({ animation, badge, all_animations }: Props) {
  const [morphPhase, setMorphPhase] = useState(0)
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    // Phases de morphing
    setTimeout(() => setMorphPhase(1), 300)
    setTimeout(() => setMorphPhase(2), 800)
    setTimeout(() => setMorphPhase(3), 1300)
    setTimeout(() => {
      setMorphPhase(4)
      setShowBadge(true)
    }, 1800)
  }, [])

  const getShapeStyle = () => {
    switch (morphPhase) {
      case 0:
        return 'w-8 h-8 rounded-full'
      case 1:
        return 'w-24 h-24 rounded-full'
      case 2:
        return 'w-32 h-32 rounded-lg rotate-45'
      case 3:
        return 'w-32 h-32 sm:w-40 sm:h-40 rounded-xl rotate-0'
      case 4:
        return 'w-32 h-32 sm:w-44 sm:h-44 rounded-2xl rotate-0'
      default:
        return 'w-8 h-8 rounded-full'
    }
  }

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        .morph-shape {
          transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* Forme qui se transforme */}
        <div className={`morph-shape ${getShapeStyle()} bg-tessan-cream flex items-center justify-center shadow-2xl shadow-tessan-yellow/50`}>
          {showBadge && <span className="text-6xl sm:text-8xl">{badge.emoji}</span>}
          {!showBadge && morphPhase > 0 && (
            <div className="w-1/2 h-1/2 bg-tessan-yellow/30 rounded-full animate-pulse" />
          )}
        </div>

        <div className={`mt-8 text-center transition-all duration-700 ${showBadge ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
